import Price from '~/libs/Price';

import { Error, ErrorCode } from './Error';

export default class FinalCalculation {
	internationalReferencePrices: Price | null;

	proposedCifPrice: Price | null;

	countryOfOriginExFactoryPrice: Price | null;

	finalPrice: Price | null;

	emptyResultReason: Error[];

	constructor(
		internationalReferencePrices: Price | null,
		proposedCifPrice: Price | null,
		countryOfOriginExFactoryPrice: Price | null,
		finalPrice: Price | null,
		emptyResultReason: Error[]
	) {
		this.internationalReferencePrices = internationalReferencePrices;
		this.proposedCifPrice = proposedCifPrice;
		this.countryOfOriginExFactoryPrice = countryOfOriginExFactoryPrice;
		this.finalPrice = finalPrice;
		this.emptyResultReason = emptyResultReason;
	}

	hasProductSettingsMissingError(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.productSettingsMissing) !== undefined;
	}

	hasReferenceCountryProductMissingError(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.referenceCountryProductMissing) !== undefined
		);
	}

	findAtMostOneProductPerCountryError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.atMostOneProductPerCountry) ?? null;
	}

	hasRequiredReferenceSettingsError(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.referenceSettingsMissing) !== undefined;
	}
}
